import styled from 'styled-components';
import { AvGroup } from 'availity-mobx-reactstrap-validation';

export default styled(AvGroup)`
  position: relative;
`;
